import { BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
import ManualLink from '../../components/ManualLink';
import { manualSectionPath } from '../../helpers/manualPath';
import { MANUAL_SECTIONS } from './manualRegistry';
import './manual.scss';

/**
 * The `/readme` index (TRIL-424). Auth-gated like every private route (wired in
 * `privateRoutes.constants.ts`). Entry into the manual is via per-page help
 * icons; this index just makes it browsable once a user has arrived.
 */
export default function ManualIndex() {
  return (
    <div className="MANUAL MANUAL--index">
      <header className="MANUAL__HEADER">
        <span className="MANUAL__EYEBROW">User Manual</span>
        <h1 className="MANUAL__TITLE">How trillirivos works</h1>
        <p className="MANUAL__LEAD">
          In-depth guides to the app&apos;s subtler mechanics. You&apos;ll
          usually arrive from a help icon on the feature itself.
        </p>
        <p className="MANUAL__EXAMPLE">
          The help icon looks like this:{' '}
          <ManualLink section="about" sub="deep-links" />
        </p>
      </header>

      <ul className="MANUAL__GRID">
        {MANUAL_SECTIONS.map((s) => (
          <li key={s.slug} className="MANUAL__CARD">
            <Link to={manualSectionPath(s.slug)} className="MANUAL__CARD__LINK">
              <BookOpen
                className="MANUAL__CARD__ICON"
                size={18}
                aria-hidden="true"
              />
              <span className="MANUAL__CARD__TITLE">{s.title}</span>
              <span className="MANUAL__CARD__SUMMARY">{s.summary}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
